// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font size stuff */
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="13px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="13px"]::before {
  content: '13px';
  font-size: 13px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: '14px';
  font-size: 14px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="15px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="15px"]::before {
  content: '15px';
  font-size: 15px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: '16px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: '18px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: '20px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: '22px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="25px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="25px"]::before {
  content: '25px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: '30px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="35px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="35px"]::before {
  content: '35px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="40px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="40px"]::before {
  content: '40px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="45px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="45px"]::before {
  content: '45px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="50px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="50px"]::before {
  content: '50px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="55px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="55px"]::before {
  content: '55px';
  font-size: 16px !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="60px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="60px"]::before {
  content: '60px';
  font-size: 16px !important;
}

.ql-picker-options {
  max-height: 150px;
  overflow-y: auto;
}

/* Font-family stuff */
#text-editor {
  font-family: "Open Sans";
  font-size: 18px;
}

#toolbar-container .ql-font span[data-label="Open Sans"]::before {
  font-family: "Open Sans";
}

.ql-customButton::before {
  content: 'Nom de zone';
}

.ql-customButton {
  width: 100px !important;
}
`, "",{"version":3,"sources":["webpack://./src/adhocV2/style.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* Font size stuff */\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"13px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"13px\"]::before {\n  content: '13px';\n  font-size: 13px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"14px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"14px\"]::before {\n  content: '14px';\n  font-size: 14px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"15px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"15px\"]::before {\n  content: '15px';\n  font-size: 15px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"16px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"16px\"]::before {\n  content: '16px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"18px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"18px\"]::before {\n  content: '18px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"20px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"20px\"]::before {\n  content: '20px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"22px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"22px\"]::before {\n  content: '22px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"25px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"25px\"]::before {\n  content: '25px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"30px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"30px\"]::before {\n  content: '30px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"35px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"35px\"]::before {\n  content: '35px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"40px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"40px\"]::before {\n  content: '40px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"45px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"45px\"]::before {\n  content: '45px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"50px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"50px\"]::before {\n  content: '50px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"55px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"55px\"]::before {\n  content: '55px';\n  font-size: 16px !important;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"60px\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"60px\"]::before {\n  content: '60px';\n  font-size: 16px !important;\n}\n\n.ql-picker-options {\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n/* Font-family stuff */\n#text-editor {\n  font-family: \"Open Sans\";\n  font-size: 18px;\n}\n\n#toolbar-container .ql-font span[data-label=\"Open Sans\"]::before {\n  font-family: \"Open Sans\";\n}\n\n.ql-customButton::before {\n  content: 'Nom de zone';\n}\n\n.ql-customButton {\n  width: 100px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
